import { myHomeCreditPaymentMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { myHomeCreditAppBreadcrumb } from "../../data/DataBreadcrumb";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import Description from "../../components/UserInterface/Description";
import { DownloadApp } from "../../components/UserInterface/DownloadApp";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import VideoComponent from "../../components/UserInterface/VideoComponent";
import { defBreadcrumb } from "../../data/DataBreadcrumb";

const MyHomeCreditApp = (props) => {
  const {
    breadcrumb,
    myHomeCreditAppBreadcrumb,
    title,
    description,
    path
  } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={myHomeCreditAppBreadcrumb} />
      <HeadingComponent headingText="My Home Credit App" />
      <Description
        margin="16px"
        font="Roboto"
        text="Bayar cicilan? Lewat Aplikasi My Home Credit aja!"
      />
      <Description
        width="660px"
        margin="16px"
        font="Roboto"
        text="Lewat My Home Credit, kamu bisa atur jumlah cicilan, dan pilih metode pembayaran sesuai yang kamu mau. "
      />
      <LayoutCenter margin="0px">
        <VideoComponent
          backgroundColor
          src="https://www.youtube.com/embed/KJ8_ZPMrHB4"
        />
      </LayoutCenter>
      <Description
        margin="16px"
        font="Roboto"
        text="Ngapain pusing kalau ada yang praktis? Download My Home Credit sekarang!"
      />
      <DownloadApp />
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = myHomeCreditPaymentMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      myHomeCreditAppBreadcrumb,
      title,
      description,
      path
    }
  };
};

export default MyHomeCreditApp;
